<template>
	<v-row no-gutters>
		<v-col cols="12" style="height: 90px; position: relative" class="text-center">
			<v-row no-gutters>
				<v-col cols="12" class="mt-3">
					<div class="search_filter">
						<v-row no-gutters class="fill-height align-center px-2 pr-0">
							<v-col cols="auto" style="position: relative; top: -1px" v-if="filterModel.length === 0">
								<SIcon name="flow-search"></SIcon>
							</v-col>
							<v-col class="text-left">
								<input
									v-model="searchString"
									v-if="filterModel.length === 0"
									:placeholder="searcText"
									ref="search"
									class="search_input"
									style="height: 36px"
								/>

								<div v-show="filterModel && filterModel.length > 0" style="">
									<transition-group name="list" tag="p">
										<div class="chip_w mr-2 my-1" v-for="filter in filterModel" :key="filter">
											<TaskLogListFilterChip
												:filter="filterItems[filter]"
												@setFilterValue="setFilterValue"
												@removeChip="removeChip(filterItems[filter])"
											/>
										</div>
									</transition-group>
								</div>
							</v-col>

							<v-col cols="auto">
								<v-menu
									ref="filters"
									v-model="filterMenu"
									:close-on-content-click="false"
									transition="slide-y-transition"
									offset-y
									eager
									content-class="filter_menu"
								>
									<template v-slot:activator="{ on, attrs }">
										<v-btn v-bind="attrs" class="filter_btn" color="#93A1BA" width="80" height="34" outlined v-on="on" style="">
											<span><v-icon class="ic_filter">mdi-filter-outline</v-icon> </span>
											<span class="fil"> Filter</span>
											<span><v-icon style="font-size: 22px; color: #93a1ba">mdi-chevron-down</v-icon></span>
										</v-btn>
									</template>
									<v-card class="py-2" width="140px">
										<h3 class="tit">Filter by</h3>
										<v-list dense class="mt-0 pt-0">
											<v-list-item-group v-model="filterModel" multiple color="primary" class="grp_list">
												<v-list-item
													class="mb-1"
													v-for="(item, n) in filterItems"
													:key="n"
													style="color: #292829; font-weight: 300; padding-left: 10px"
												>
													{{ item.name }}
												</v-list-item>
											</v-list-item-group>
										</v-list>
									</v-card>
								</v-menu>
							</v-col>
						</v-row>
					</div>
				</v-col>
			</v-row>
			<v-row class="mt-0">
				<v-col cols="auto" class="text-left">
					<TaskLogListFilterDatePicker :dateRange.sync="dateRange" />
				</v-col>
				<v-col class="text-right">
					<v-btn @click="loadTasks()" icon style="border: 1px solid #dfe4ef; border-radius: 8px !important" width="80" height="34">
						Search
					</v-btn>
				</v-col>
			</v-row>
		</v-col>
	</v-row>
</template>

<script>
import moment from 'moment';
import { mapGetters, mapActions } from 'vuex';

import api from '@/api';
import TaskLogListFilterChip from '@/components/TaskLog/TaskLogListFilterChip';
import TaskLogListFilterDatePicker from '@/components/TaskLog/TaskLogListFilterDatePicker';
import { selectedProjectId } from '@/store/modules/selectedProject/getters';
import { VIRTUAL_PROJECT_IDS } from '@/utils/projects.const';

export default {
	name: 'TaskLogListFilter',
	components: {
		TaskLogListFilterDatePicker,
		TaskLogListFilterChip,
	},
	computed: {
		...mapGetters(['apps/getAllServices', 'projects/projectsList']),
		...mapGetters([selectedProjectId.fullPath]),
		projects() {
			return this['projects/projectsList'];
		},
		kitItems() {
			return this.projects.map((project) => ({ id: project.id, name: project.title }));
		},
		filterItems() {
			return [
				{ id: 0, key: 'flow', name: 'Feature', items: this.workflows, filterValue: '' },
				{ id: 1, key: 'status', name: 'Status', items: this.statusItems, filterValue: '' },
				//{id: 0, key: 'kit', name: 'Kit', items: this.kitItems, filterValue: '' },
				//{id: 1, name: 'User', items: this.userItems, filterValue: ''},
				//{id: 2, name: 'App', items: this.appItems, filterValue: ''},
				//{id: 4, name: 'Errored step', items: this.errItems, filterValue: ''},
			];
		},
		statusItems() {
			return [
				{ name: 'successful', id: 'done' },
				{ name: 'started', id: 'started' },
				{ name: 'canceled', id: 'canceled' },
				{ name: 'error', id: 'error' },
			];
		},
		errItems() {
			return ['1', '2'];
		},
		userItems() {
			return ['1', '2'];
		},
		appItems() {
			return this['apps/getAllServices'];
		},
		currentFilterItems() {
			if (this.focusedChip == 2) {
				return this.appItems;
			} else {
				return [{ name: 'a' }, { name: 'b' }];
			}
		},
		isMultiple() {
			return false;
		},
		searcText() {
			var txt = '';
			if (this.filterModel.length < 1) {
				txt = 'Search features';
			} else {
				return 'Search ' + this.filterItems[this.filterModel];
			}
			return txt;

			// console.log('this.filterModel: ', this.filterModel)
			// return txt
		},
	},
	watch: {},
	methods: {
		...mapActions('analytics', ['getTaskLog']),
		async loadFlows() {
			const r = await api.getFlows(1, { page_size: 100 }, true);
			if (!r) {
				return [];
			}
			this.workflows = r.map((workflow) => ({
				name: workflow.workflow_title,
				id: workflow.id,
			}));
		},
		loadTasks() {
			this.clearSelectedItem();
			let params = {};
			if (this.dateRange.length === 2) {
				let date1ISO = moment(this.dateRange[0]).set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
				date1ISO = date1ISO.toISOString();
				let date2ISO = moment(this.dateRange[1]).set({ hour: 23, minute: 59, second: 59 });
				date2ISO = date2ISO.toISOString();
				params['dateRange'] = `${date1ISO},${date2ISO}`;
			}
			params = { ...params, ...this.filterValues };
			this.getTaskLogs(params);
		},
		async getTaskLogs(params) {
			const { projectId, allTasks } = params;
			if (!projectId && !allTasks && !VIRTUAL_PROJECT_IDS.includes(this[selectedProjectId.fullPath])) {
				params.projectId = this[selectedProjectId.fullPath];
			}
			this.$emit('get-task-logs', params);
		},
		removeChip(chip) {
			console.log('removeChip:', chip);
			const ind = this.filterModel.indexOf(chip.id);
			this.filterModel.splice(ind, 1);
			console.log('ind: ', ind);
			delete this.filterValues[chip.key];
		},
		setFilterValue(filter, value) {
			this.filterValues[filter.key] = value;
		},
		shrinkChip() {
			this.focusedChip = null;
		},
		selectItem() {},
		isSelected() {},
		rangeClick() {},
		clearSelectedItem() {
			this.$emit('clearSelectedItem');
		},
	},
	created() {
		this.loadFlows();
	},
	data: () => ({
		workflows: [],
		focusedChip: null,
		filterItemChosen: null,
		filterModel: [],
		filterValues: {},
		selectedItem: '',
		filterMenu: false,
		searchString: '',
		dateRange: [],
		dateRangeMenu: false,
	}),
};
</script>

<style scoped>
.filter_btn {
	border-radius: 7px !important;
	border-top-left-radius: 0px !important;
	border-bottom-left-radius: 0px !important;
	border: none;
	border-left: 1px solid #dfe4ef;
	text-transform: none !important;
	letter-spacing: 0.02em;
}
.v-text-field {
	height: 30px !important;
	min-height: 30px !important;
}
.ic_filter {
	font-size: 16px;
	color: #93a1ba;
}
.search_input {
	width: 100%;
	height: 100%;
	text-indent: 5px;
	font-size: 12px;
	line-height: 32px !important;
}
.search_filter {
	border: 1px solid #dfe4ef;
	border-radius: 8px !important;
	min-height: 36px;
	transition: all 0.2s;
	position: relative;
	display: inline-block;
	width: 100%;
}
h3.tit {
	font-weight: 600;
	padding-left: 10px;
}
input:focus {
	outline: none;
}
.v-btn.filter_btn {
	border-radius: 0px !important;
	position: relative;
	top: -1px;
	border-top-right-radius: 8px !important;
	border-bottom-right-radius: 8px !important;
}
.ic_filter {
	font-size: 14px;
	top: -1px;
}
.fil {
	left: 1px;
	position: relative;
	font-size: 14px !important;
	font-weight: 400 !important;
}
.chip_w {
	height: 25px;
	line-height: 25px;
	padding: 0px 6px;
	background: #eff1f7;
	border-radius: 13px;
	font-size: 14px !important;
	color: #292829;
	display: inline-block;
	text-align: left;
	transition: all 0.2s;
}

p {
	line-height: 32px !important;
	transition: all 0.2s;
}
.filter_menu {
	border: 1px solid #e7e7ed !important;
	box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.2) !important;
	border-radius: 3px !important;
}
</style>
